const country = {
  en: {
    country: {
      country: 'Country | Countries',
      household: 'Household | Households',
      select_country_amount: 'One country selected | Countries selected: <strong>{amount}</strong>',
      total_households: 'Total Households',
      action_to_all_countries: 'All filtered countries ({total})',
      action: {
        find: 'Find'
      },
      form: {
        edit: {
          title: 'Edit Country | Edit Countries'
        },
        message: {
          updated: 'Country updated | Contries updated'
        },
        button: {
          edit: 'Edit',
          cancel: 'Cancel'
        },
      },
      subscription: {
        title: 'Subscribed Countries',
        add_country: 'Add Country',
        country_name: 'Country Name',
        iso_code: 'ISO Code',
        actions: 'Actions',
        remove: 'Remove',
        select_country: 'Select Country',
        search_placeholder: 'Search countries...',
        loading: 'Loading...',
        unknown_country: 'Unknown ({code})',
        messages: {
          added_success: 'Country added successfully',
          removed_success: 'Country removed successfully',
          add_error: 'Failed to add country. Please try again.',
          remove_error: 'Failed to remove country. Please try again.'
        },
        modal: {
          title: 'Add Country',
          cancel: 'Cancel',
          add: 'Add Country'
        }
      }
    }
  }
}

module.exports.country = country;